function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { UIPlugin } from '@uppy/core';
import { h } from 'preact';
import Editor from "./Editor.js";
var packageJson = {
  "version": "2.1.2"
};
import locale from "./locale.js";
var ImageEditor = /*#__PURE__*/function (_UIPlugin) {
  _inherits(ImageEditor, _UIPlugin);
  var _super = _createSuper(ImageEditor);
  function ImageEditor(uppy, opts) {
    var _this;
    _classCallCheck(this, ImageEditor);
    _this = _super.call(this, uppy, opts);
    _this.save = function () {
      var saveBlobCallback = function saveBlobCallback(blob) {
        var _this$getPluginState = _this.getPluginState(),
          currentImage = _this$getPluginState.currentImage;
        _this.uppy.setFileState(currentImage.id, {
          data: blob,
          size: blob.size,
          preview: null
        });
        var updatedFile = _this.uppy.getFile(currentImage.id);
        _this.uppy.emit('thumbnail:request', updatedFile);
        _this.setPluginState({
          currentImage: updatedFile
        });
        _this.uppy.emit('file-editor:complete', updatedFile);
      };
      var _this$getPluginState2 = _this.getPluginState(),
        currentImage = _this$getPluginState2.currentImage;
      _this.cropper.getCroppedCanvas(_this.opts.cropperOptions.croppedCanvasOptions).toBlob(saveBlobCallback, currentImage.type, _this.opts.quality);
    };
    _this.storeCropperInstance = function (cropper) {
      _this.cropper = cropper;
    };
    _this.selectFile = function (file) {
      _this.uppy.emit('file-editor:start', file);
      _this.setPluginState({
        currentImage: file
      });
    };
    _this.id = _this.opts.id || 'ImageEditor';
    _this.title = 'Image Editor';
    _this.type = 'editor';
    _this.defaultLocale = locale;
    var defaultCropperOptions = {
      viewMode: 1,
      background: false,
      autoCropArea: 1,
      responsive: true,
      croppedCanvasOptions: {}
    };
    var defaultActions = {
      revert: true,
      rotate: true,
      granularRotate: true,
      flip: true,
      zoomIn: true,
      zoomOut: true,
      cropSquare: true,
      cropWidescreen: true,
      cropWidescreenVertical: true
    };
    var defaultOptions = {
      quality: 0.8
    };
    _this.opts = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), opts), {}, {
      actions: _objectSpread(_objectSpread({}, defaultActions), opts.actions),
      cropperOptions: _objectSpread(_objectSpread({}, defaultCropperOptions), opts.cropperOptions)
    });
    _this.i18nInit();
    return _this;
  } // eslint-disable-next-line class-methods-use-this
  _createClass(ImageEditor, [{
    key: "canEditFile",
    value: function canEditFile(file) {
      if (!file.type || file.isRemote) {
        return false;
      }
      var fileTypeSpecific = file.type.split('/')[1];
      if (/^(jpe?g|gif|png|bmp|webp)$/.test(fileTypeSpecific)) {
        return true;
      }
      return false;
    }
  }, {
    key: "install",
    value: function install() {
      this.setPluginState({
        currentImage: null
      });
      var target = this.opts.target;
      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      var _this$getPluginState3 = this.getPluginState(),
        currentImage = _this$getPluginState3.currentImage;
      if (currentImage) {
        var file = this.uppy.getFile(currentImage.id);
        this.uppy.emit('file-editor:cancel', file);
      }
      this.unmount();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getPluginState4 = this.getPluginState(),
        currentImage = _this$getPluginState4.currentImage;
      if (currentImage === null || currentImage.isRemote) {
        return null;
      }
      return h(Editor, {
        currentImage: currentImage,
        storeCropperInstance: this.storeCropperInstance,
        save: this.save,
        opts: this.opts,
        i18n: this.i18n
      });
    }
  }]);
  return ImageEditor;
}(UIPlugin);
export { ImageEditor as default };
ImageEditor.VERSION = packageJson.version;